var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c("submission", {
            ref: "submission",
            on: { "get-content-value": _vm.getContentValue },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShow
        ? _c("edit-examine", {
            ref: "editExamine",
            attrs: { typeNum: _vm.typeNum },
            on: {
              isOk: function ($event) {
                return _vm.getTableData()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }